import { ComponentProps, lazy, LazyExoticComponent, Suspense } from "react";
import type DesktopUnavailableNotice from "./DesktopUnavailable";

let Notice: LazyExoticComponent<typeof DesktopUnavailableNotice> | undefined;

// The "not available in the offline desktop app" notice: everything else imports this wrapper, never the
// component itself. The comparison below is the raw build-time variable on purpose. webpack only knows its value
// while parsing (not through the imported flag in utils/desktopProfile.ts), and only then can it drop the
// import() with it - so on the website the notice, its stylesheet and its chunk are not built at all.
export default function DesktopUnavailable(props: ComponentProps<typeof DesktopUnavailableNotice>) {
    if (process.env.REACT_APP_DESKTOP_LOCAL_PROFILE === "true") {
        Notice = Notice ?? lazy(() => import("./DesktopUnavailable"));
        return <Suspense fallback={null}><Notice {...props} /></Suspense>;
    }
    return null;
}
